// extracted by mini-css-extract-plugin
module.exports = {"contentLang":"LanguageItems_contentLang__1RR9-","active":"LanguageItems_active__1KTFa"};